import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


import { ConstantService } from '../constants/constant.service';

@Injectable()
export class AuthenticationService {

    headers;
    constructor(private http: Http,
        @Inject(ConstantService) private constantService: ConstantService,
        private router: Router) {
    }

    login(formData) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(this.constantService.baseURL + '/api/v3/authenticate/admin',
            JSON.stringify(formData), options)
            .map((response: Response) => {
                let user = response.json();
                if (user && user.token) {
                    localStorage.setItem('token', user.token);
                    if (user.tester_account) {
                        localStorage.setItem('tester_account', user.tester_account.toString());
                    }
                }
                return user;
            },
            error => {

            });
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('tester_account');
        this.router.navigate(['/login']);
    }

    changePassword(formData) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            "Authorization": "Bearer " + localStorage.getItem('token')
        });
        let options = new RequestOptions({ headers: headers });

        return this.http.put(this.constantService.baseURL + '/api/v3/user/changepassword',
            JSON.stringify(formData), options)
            .map((response: Response) => {
                return response.json();
            },
            error => {

            });
    }
}


// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/services/authentication.service.ts